import { Conjunction } from '@/modules/common/enums/conjunction.enum.ts';
import { Operator } from '@/modules/viewer/enums/operator.enum.ts';
import type {
  ConditionRequest,
  ConditionValue,
  GroupRequest,
  NodeRequest,
} from '@/modules/core/requests/execute.request.ts';

function condition(field: string, operator: Operator, value?: ConditionValue): ConditionRequest {
  return value === undefined ? { field, operator } : { field, operator, value };
}

function group(logic: Conjunction, nodes: (NodeRequest | null | undefined)[]): GroupRequest | undefined {
  const conditions = nodes.filter((node): node is NodeRequest => !!node);

  if (!conditions.length) {
    return;
  }

  return { logic, conditions };
}

export const GatewayFilter = {
  condition,
  eq: (field: string, value: ConditionValue) => condition(field, Operator.Equals, value),
  notEq: (field: string, value: ConditionValue) => condition(field, Operator.NotEquals, value),
  in: (field: string, value: (string | number | boolean)[]) => condition(field, Operator.In, value),
  contains: (field: string, value: string) => condition(field, Operator.Contains, value),
  isTrue: (field: string) => condition(field, Operator.True, true),
  isFalse: (field: string) => condition(field, Operator.False, false),
  empty: (field: string) => condition(field, Operator.Empty),
  notEmpty: (field: string) => condition(field, Operator.NotEmpty),
  and: (...nodes: (NodeRequest | null | undefined)[]) => group(Conjunction.And, nodes),
  or: (...nodes: (NodeRequest | null | undefined)[]) => group(Conjunction.Or, nodes),
};
